export default "__VITE_ASSET__DaYjQUGm__"